import { Goal, ID, LinkedItemSection, UpdateGoal } from '@griply/types';

export type BuildSectionDuplicateUpdateOptions = {
  sectionId: ID;
  newSection: LinkedItemSection;
  taskCount: number;
  completedTaskCount: number;
};

// `taskCount` / `completedTaskCount` are signed deltas (applied via `increment`),
// not absolutes. The duplicate lands directly below its source section. Uses
// slice-based insertion because `Array.prototype.toSpliced` is unsupported on
// Hermes (this util runs on both web and mobile).
export const buildSectionDuplicateUpdate = (
  goal: Goal,
  {
    sectionId,
    newSection,
    taskCount,
    completedTaskCount,
  }: BuildSectionDuplicateUpdateOptions,
): UpdateGoal => {
  const sections = goal.sections ?? [];
  const insertAt = sections.findIndex(({ id }) => id === sectionId) + 1;

  return {
    id: goal.id,
    sections: [
      ...sections.slice(0, insertAt),
      newSection,
      ...sections.slice(insertAt),
    ],
    taskCount,
    completedTaskCount,
  };
};
